module.exports = __webpack_public_path__ + "static/media/landing-background.e7690561.jpg";